import React from "react"
import { Badge } from "reactstrap"
import { formatearNumero } from "helpers/formatters"
import {
  categorizarResultados,
  etiquetaResultado,
} from "./migracionEstadoHelpers"

// Desglose por motivo (resultado) de las no importadas, de mayor a menor. Solo
// `resultado` con conjunto cerrado y tope (ver categorizarResultados); nunca
// texto libre ni datos personales.
export function desglosarNoImportadas(noImportadas) {
  return categorizarResultados(noImportadas)
    .map(({ name, value }) => ({
      resultado: name,
      etiqueta: etiquetaResultado(name === "DESCONOCIDO" ? "" : name),
      cantidad: value,
    }))
    .sort((a, b) => b.cantidad - a.cantidad)
}

// `decimales`: 0 por defecto (conteos); las cantidades con fracción (QQ, USD) lo suben a 2.
export function TarjetaNumero({ etiqueta, valor, color, testId, decimales = 0 }) {
  return (
    <div className="text-center" data-testid={testId}>
      <h4>
        <Badge color={color}>{formatearNumero(valor, decimales)}</Badge>
      </h4>
      <small className="text-muted">{etiqueta}</small>
    </div>
  )
}

// Tarjeta "No importados": numero total + desglose por motivo.
export function TarjetaNoImportados({ total, desglose, testId }) {
  return (
    <div className="text-center" data-testid={testId}>
      <h4>
        <Badge color="danger" data-testid={`${testId}-total`}>
          {formatearNumero(total, 0)}
        </Badge>
      </h4>
      <small className="text-muted">No importados</small>
      {desglose.length > 0 && (
        <ul
          className="list-unstyled small mb-0 mt-1"
          data-testid={`${testId}-desglose`}
        >
          {desglose.map(d => (
            <li key={d.resultado}>
              {d.etiqueta}: {formatearNumero(d.cantidad, 0)}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
